import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { AiReservationControllerGetAiReservationHistoryCountParams } from '@/apis/swaggers/v3/api/ai/ai-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<AiReservationControllerGetAiReservationHistoryCountParams, unknown>

const fetchAiReservationCount = async (params: AiReservationControllerGetAiReservationHistoryCountParams) => {
  const { data } = await apiClient.v3.aiReservationControllerGetAiReservationHistoryCount(params);
  return checkApiResponse(data);
}

export const aiReservationCountKeys = {
  all: [QUERY_KEY.aiReservationControllerGetAiReservationHistoryCount] as const,
  list: (params: AiReservationControllerGetAiReservationHistoryCountParams) => [...aiReservationCountKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(aiReservationCountQueryOptions(params))` */
export const aiReservationCountQueryOptions = (params: AiReservationControllerGetAiReservationHistoryCountParams) => ({
  queryKey: aiReservationCountKeys.list(params),
  queryFn: () => fetchAiReservationCount(params),
})

export const useAiReservationCountQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: aiReservationCountKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchAiReservationCount(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
